/**
 * Lullabee custom product behaviour ported from Prestige 5.7 to 11.4.1.
 * - halfunit tag: quantity is sold in 0.5 metre steps
 * - show-swatch tag: Order A Sample button
 * - thread_ tags: matching thread add-on
 */

function metresFromQuantity(count) {
  return count / 2;
}

function yardsFromQuantity(count) {
  return Math.round((count * 109.361) / 2) / 100;
}

function formatLengthLabel(count) {
  return metresFromQuantity(count) + ' METERS (' + yardsFromQuantity(count) + ' YARDS)';
}

function formatLengthProperty(count) {
  return metresFromQuantity(count) + ' METERS';
}

function formatMoney(cents) {
  const rawFormat = window.themeVariables?.settings?.moneyFormat || '£{{amount}}';
  const placeholderMatch = String(rawFormat).match(/\{\{\s*(\w+)\s*\}\}/);
  const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
  const amount = formatMoneyAmount(cents, placeholder);
  const html = String(rawFormat).replace(/\{\{\s*\w+\s*\}\}/, amount);
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').trim();
}

function formatMoneyAmount(cents, placeholder) {
  const value = Math.round(Number(cents) || 0);

  function withDelimiters(precision, thousands, decimal) {
    const fixed = (value / 100).toFixed(precision);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }

  switch (placeholder) {
    case 'amount_no_decimals':
      return withDelimiters(0, ',', '.');
    case 'amount_with_comma_separator':
      return withDelimiters(2, '.', ',');
    case 'amount_no_decimals_with_comma_separator':
      return withDelimiters(0, '.', ',');
    case 'amount_with_apostrophe_separator':
      return withDelimiters(2, "'", '.');
    case 'amount_no_decimals_with_space_separator':
      return withDelimiters(0, ' ', '.');
    case 'amount_with_space_separator':
      return withDelimiters(2, ' ', ',');
    case 'amount_with_period_and_space_separator':
      return withDelimiters(2, ' ', '.');
    default:
      return withDelimiters(2, ',', '.');
  }
}

function updateBuyButtonPrice(count) {
  document.querySelectorAll('.buy-btn-price[data-vprice]').forEach(function (priceEl) {
    const unitPrice = parseInt(priceEl.getAttribute('data-vprice'), 10);
    if (Number.isNaN(unitPrice)) return;
    priceEl.textContent = formatMoney(unitPrice * count);
  });
}

function syncHalfunitInputWidth(selector) {
  const mask = selector?.querySelector('.quantity-mask');
  const wrapper = selector?.querySelector('quantity-input, .quantity-selector__input-wrapper');
  if (!mask || !wrapper) return;
  wrapper.style.setProperty('--quantity-selector-character-count', `${Math.max(String(mask.value).length, 3)}ch`);
}

function getHalfunitRoot(element) {
  return element.closest('.tt-half-price') || element.closest('[data-halfunit]')?.parentElement;
}

function syncHalfunitFromQuantity(quantityInput) {
  const selector = quantityInput.closest('quantity-selector');
  if (!selector || !selector.hasAttribute('data-halfunit')) return;

  const count = Math.max(parseInt(quantityInput.value, 10) || 1, 1);
  quantityInput.value = count;

  const mask = selector.querySelector('.quantity-mask');
  const root = getHalfunitRoot(selector);
  const label = root?.querySelector('.qty-infor-str');
  const lengthInput = root?.querySelector('.qty-infor-data');

  if (mask) mask.value = metresFromQuantity(count);
  if (label) label.textContent = formatLengthLabel(count);
  if (lengthInput) lengthInput.value = formatLengthProperty(count);

  updateBuyButtonPrice(count);
  syncHalfunitInputWidth(selector);
}

function syncHalfunitFromMask(maskInput) {
  const selector = maskInput.closest('quantity-selector');
  if (!selector) return;

  let metres = parseFloat(maskInput.value);
  if (Number.isNaN(metres)) metres = 0.5;

  metres = Math.round(metres * 2) / 2;
  if (metres < 0.5) metres = 0.5;

  maskInput.value = metres;

  const count = Math.round(metres * 2);

  if (selector && 'quantity' in selector) {
    selector.quantity = count;
  }

  const root = getHalfunitRoot(selector);
  const label = root?.querySelector('.qty-infor-str');
  const lengthInput = root?.querySelector('.qty-infor-data');

  if (label) label.textContent = formatLengthLabel(count);
  if (lengthInput) lengthInput.value = formatLengthProperty(count);

  updateBuyButtonPrice(count);
  syncHalfunitInputWidth(selector);
}

async function addProductToSampleToCart(elem, vid, prodTitle) {
  const variantId = vid || elem?.getAttribute('data-variant-id');
  const title = prodTitle || elem?.getAttribute('data-product-title') || '';

  if (!variantId) return;

  const sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    })
  );

  document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

  try {
    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    formData.set('properties[Product]', title);
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', window.location.pathname);

    const addResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });

    const addJson = await addResponse.json();
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    if (!addResponse.ok) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      throw new Error(addJson.description || 'Unable to add sample');
    }

    const cartContent = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
    cartContent.sections = addJson.sections;

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      })
    );
  } catch (error) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    console.error(error);
  }
}

document.addEventListener('change', function (event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;

  if (target.matches('quantity-selector[data-halfunit] .quantity-selector__input--actual, quantity-selector[data-halfunit] input[name="quantity"]')) {
    syncHalfunitFromQuantity(target);
  }

  if (target.matches('.quantity-mask')) {
    syncHalfunitFromMask(target);
  }
});

document.addEventListener('click', function (event) {
  const sampleButton = event.target.closest('.js-order-sample');
  if (sampleButton) {
    event.preventDefault();
    addProductToSampleToCart(sampleButton);
    return;
  }

  const threadButton = event.target.closest('.js-add-thread');
  if (threadButton) {
    event.preventDefault();
    addProductToSampleToCart(threadButton);
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const threadButton = event.target.closest('.js-add-thread');
  if (!threadButton) return;
  event.preventDefault();
  addProductToSampleToCart(threadButton);
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('quantity-selector[data-halfunit]').forEach(syncHalfunitInputWidth);
});

(function patchCartChangeLength() {
  const nativeFetch = window.fetch.bind(window);

  function isHalfunitLine(lineKey) {
    if (!lineKey) return false;
    return Array.from(document.querySelectorAll('quantity-selector[data-halfunit] [data-line-key]')).some(function (input) {
      return input.getAttribute('data-line-key') === lineKey;
    });
  }

  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : input && input.url;
      if (url && String(url).indexOf('/cart/change') !== -1 && init && typeof init.body === 'string') {
        const body = JSON.parse(init.body);
        if (body && body.id && body.quantity > 0 && isHalfunitLine(body.id)) {
          body.properties = Object.assign({}, body.properties, {
            Length: formatLengthProperty(body.quantity)
          });
          init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      }
    } catch (error) {
      // Keep the original cart request if the body cannot be patched.
    }

    return nativeFetch(input, init);
  };
})();
